// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pageBackBarInner_2Chqg{display:flex;align-items:center;width:100%;height:var(--height-header);line-height:1}.back_3Ltl9{margin-right:calc(var(--gap)/2);color:var(--v-primary-base);font-size:24px}.label_2C82l{color:var(--color-text-default);font-weight:700}.label_2C82l:not(.hasThumb_2teUj){text-align:center;flex:1;padding-right:20px}.userImage_24ZOL{width:34px;margin-right:calc(var(--gutter)/2)}.button_1wCQ1{margin-left:auto}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageBackBarInner": "pageBackBarInner_2Chqg",
	"back": "back_3Ltl9",
	"label": "label_2C82l",
	"hasThumb": "hasThumb_2teUj",
	"userImage": "userImage_24ZOL",
	"button": "button_1wCQ1"
};
module.exports = ___CSS_LOADER_EXPORT___;
